import { post, put, deleteReq } from './api';

export const createFragment = ({ bookletId, sectionId, body }) =>
  post(
    `/booklets/${bookletId}/sections/${sectionId}/fragments`,
    JSON.stringify(body),
    {
      'Content-Type': 'application/json',
    }
  );

export const updateFragment = ({ bookletId, sectionId, id, body }) =>
  put(
    `/booklets/${bookletId}/sections/${sectionId}/fragments/${id}`,
    JSON.stringify(body),
    {
      'Content-Type': 'application/json',
    }
  );

export const deleteFragment = ({ bookletId, sectionId, fragmentId: id }) =>
  deleteReq(`/booklets/${bookletId}/sections/${sectionId}/fragments/${id}`, {
    'Content-Type': 'application/json',
  });



// WEBPACK FOOTER //
// ./src/services/fragmentApi.js